{
  "page_title": "Kunder",
  "table": {
    "name": "Namn",
    "code": "Kod",
    "country": "Land",
    "created": "Skapad",
    "click_to_edit": "Klicka för att redigera",
    "type": "Typ",
    "features": "Funktioner",
    "no_matches": "Inga kunder matchar sökningen"
  },
  "create": {
    "title": "Skapa ny kund",
    "subtitle": "Lägg till en ny golfklubb eller organisation i systemet",
    "breadcrumb": "Ny kund",
    "success": "Kunden \"{{name}}\" skapades framgångsrikt!",
    "error": "Det gick inte att skapa kunden: {{message}}",
    "submit_button": "Skapa kund"
  },
  "edit": {
    "breadcrumb": "Redigera",
    "success": "Kunden \"{{name}}\" uppdaterades framgångsrikt!",
    "error": "Det gick inte att uppdatera kunden: {{message}}",
    "submit_button": "Uppdatera kund",
    "error_loading": "Fel vid inläsning av kund",
    "back_to_list": "Tillbaka till kundlistan"
  },
  "delete": {
    "danger_zone": "Riskzon",
    "danger_zone_description": "När du tar bort en kund så mjukraderas den och alla administratörsanslutningar tas bort. Denna åtgärd påverkar alla användare som är kopplade till denna kund.",
    "button": "Ta bort kund",
    "confirm_header": "Ta bort kund \"{{name}}\"",
    "confirm_body": "Är du säker på att du vill ta bort kunden \"{{name}}\"?\n\nDetta kommer att:\n• Mjukradera kunden (sätta deletedAt-tidsstämpel)\n• Ta bort alla administratörsanslutningar\n• Göra kunden otillgänglig för användare\n\nDenna åtgärd kan granskas i systemloggar, men bör göras varsamt.",
    "confirm_button": "Ta bort kund",
    "success": "Kunden \"{{name}}\" har tagits bort framgångsrikt.",
    "error": "Det gick inte att ta bort kunden: {{message}}"
  },
  "form": {
    "tabs": {
      "basic": "Grunduppgifter",
      "contact": "Kontaktuppgifter",
      "payment": "Inställningar",
      "managers": "Användare"
    },
    "fields": {
      "name": {
        "label": "Kundnamn",
        "placeholder": "Ange golfklubbens namn",
        "help": "Det officiella registrerade namnet på golfklubben eller organisationen."
      },
      "code": {
        "label": "Kundkod",
        "placeholder": "klubb-kod",
        "help": "Unik identifierare som används i URL:er. Endast små bokstäver, siffror och bindestreck.",
        "available": "Koden \"{{code}}\" är tillgänglig",
        "taken": "Koden \"{{code}}\" är redan upptagen"
      },
      "display_name": {
        "label": "Visningsnamn",
        "placeholder": "Kort visningsnamn (valfritt)",
        "help": "Valfritt kortare namn för visning."
      },
      "country": {
        "label": "Land",
        "placeholder": "Välj land",
        "help": "Landet där golfklubben finns."
      },
      "paytrailMerchantId": {
        "label": "Paytrail-handlar-ID",
        "placeholder": "",
        "help": "Shop-in-Shop underhandlar-ID för betalningsdelning."
      },
      "vatRate": {
        "label": "Momssats",
        "placeholder": "",
        "help": "Standard momssats (t.ex. 13,5 %)."
      },
      "commissionRate": {
        "label": "Provisionssats",
        "placeholder": "",
        "help": "XenGolf-tjänstens provision på betalningar (t.ex. 2,5 %)."
      },
      "batch_submission_time": {
        "label": "eBirdie-sändningstid",
        "help": "Tid på dagen då resultat automatiskt skickas till eBirdie."
      },
      "latitude": {
        "label": "Latitud",
        "placeholder": "t.ex. 60.1699"
      },
      "longitude": {
        "label": "Longitud",
        "placeholder": "t.ex. 24.9384"
      },
      "ebirdie_club": {
        "label": "Hämta data från eBirdie",
        "title": "Välj eBirdie-klubb",
        "placeholder": "Välj klubb",
        "loading": "Laddar klubbar...",
        "prefilling": "Hämtar data...",
        "error": "Det gick inte att hämta klubbar",
        "help": "Välj en klubb för att förifylla formuläret med eBirdie-data.",
        "select_button": "Välj",
        "skip_button": "Fortsätt utan val"
      },
      "commissionFixed": {
        "label": "Fast provision (€)",
        "placeholder": "",
        "help": "Fast provision i euro som dras av från betalningar som redovisas till klubben."
      },
      "type": {
        "label": "Kundtyp",
        "club": "Klubb",
        "society": "Sällskap",
        "union": "Förbund",
        "help": "Kundtyp: Klubb, Sällskap eller Förbund. Kan inte ändras efter skapandet."
      },
      "ebirdieEnabled": {
        "label": "eBirdie aktiverat",
        "help": "När avstängt döljs eBirdie-funktioner från tävlingshanteringen och resultat skickas inte till eBirdie."
      },
      "system36Enabled": {
        "label": "System 36 aktiverat",
        "help": "När påslaget kan System 36 väljas som resultattyp för serien."
      },
      "addOnsEnabled": {
        "label": "Tilläggstjänster aktiverade",
        "help": "När aktiverat visas hantering av tilläggstjänster i Admin-menyn."
      },
      "pollsEnabled": {
        "label": "Enkäter aktiverade",
        "help": "När aktiverat visas hanteringen av banans feedbackenkäter i Admin-menyn och en enkät kan visas för spelare efter rundan."
      }
    },
    "validation": {
      "name_required": "Kundnamn krävs",
      "name_min_length": "Kundnamnet måste vara minst 2 tecken",
      "code_required": "Kundkod krävs",
      "code_pattern": "Kundkoden får bara innehålla små bokstäver, siffror och bindestreck",
      "code_min_length": "Kundkoden måste vara minst 3 tecken",
      "code_max_length": "Kundkoden får inte överstiga 50 tecken",
      "email_invalid": "Ogiltig e-postadress",
      "vat_required_with_merchant": "Momssats krävs när handlar-ID är angivet"
    },
    "unsaved_changes": "Du har osparade ändringar",
    "saving": "Sparar...",
    "save": "Spara",
    "cards": {
      "features": "Funktioner",
      "payment": "Betalning"
    }
  },
  "managers": {
    "current": "Nuvarande användare",
    "no_managers": "Inga användare tilldelade denna kund",
    "no_managers_help": "Lägg till användare",
    "add_manager": "Lägg till användare",
    "search_placeholder": "Sök användare efter e-post eller namn...",
    "reload": "Uppdatera tillgängliga användare",
    "loading": "Laddar användare...",
    "no_results": "Inga användare hittades för \"{{searchTerm}}\"",
    "no_results_help": "Prova ett annat sökord",
    "no_available": "Inga tillgängliga användare",
    "no_available_help": "Alla användare är redan tilldelade kunder eller borttagna.",
    "showing_first_10": "Visar de 10 första resultaten. Fortsätt skriva för att begränsa.",
    "remove_manager": "Ta bort användare"
  },
  "list": {
    "search_placeholder": "Sök med namn eller kod",
    "type_filter_all": "Alla typer",
    "features": {
      "payments": "Betalningar",
      "ebirdie": "eBirdie",
      "system36": "System 36",
      "addons": "Tilläggstjänster",
      "polls": "Enkäter"
    },
    "feature_enabled": "{{feature}} aktiverad",
    "feature_disabled": "{{feature}} inte aktiverad",
    "legend": {
      "enabled": "Aktiverad",
      "disabled": "Inte aktiverad"
    }
  }
}
